import { SvgIcon } from "@mui/material";

export default function StepIntoIcon() {
    return (
        <SvgIcon viewBox="0 0 16 16">
            <path d="M8 9.532h.542l3.905-3.905-1.061-1.06-2.637 2.61V1H7.251v6.177l-2.637-2.61-1.061 1.06 3.905 3.905H8Z m1.956 3.481a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
        </SvgIcon>
    );
}
